import React, {useState,useEffect,useContext } from "react";
import { useLocation } from "react-router";
function QuizApp1(props) {
  const greeting = 'Hello Function Component!';
  let data = useLocation();
  ////console.log(data.state)
 
  return <h1>{greeting}</h1>;
}
 
export default QuizApp1;